import type { ApiRoute, NoBody, NoPathParams } from "../api"
import type { InventoryListFilterView } from "./InventoryListFilterView"

export interface GetInventoryListFilterViewQueryParams {
	bodyTypes?: string[]
	derivatives?: string[]
	modelGenerations?: string[]
	modelSeries?: string
}

export const getInventoryListFilterViewRoute: ApiRoute<
	NoPathParams,
	GetInventoryListFilterViewQueryParams,
	NoBody,
	InventoryListFilterView
> = {
	buildUrl: () => "/inventory-filter",
	method: "get",
	path: "/inventory-filter",
}
